import { createAsyncThunk } from "@reduxjs/toolkit";

import { dataServer, uploadsServer } from "~/constants";
import RoleTypesIds from "~/containers/App/RoleTypes";
import type { RootState } from "~/store";

import type { OrgConnection } from "~/types/allocations";
import type { Asset, BridgeModel } from "~/types/bridge";
import type { Survey } from "~/types/general";
import type { SaveElementsData } from "../components/ElementsComparisonModule/types";
import type { Annotation } from "~/types/annotations";



export const createDocument = async (url: string, object: Record<string, any>) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(object),
    });
    const data = await response.json();
    console.log("updateDocument response", data);
    if (!response.ok) {
      throw new Error(data);
    }
    return data;
  } catch (error) {
    throw error;
  }
}

export const createThunk = createAsyncThunk(
  "organization/createThunk",
  async ({ dataType, data }: { dataType: string; data: Record<string, any> }, { rejectWithValue, dispatch }) => {
    console.log("createThunk params", { dataType, data });
    const url = `${dataServer}single/${dataType}`;
    try {
      const result = await createDocument(
        url,
        data
      )
      console.log("createThunk result", result);
      // dispatch(setOrgani)
      if (result.success) {
        return {
          dataType,
          data: result.data
        };
      } else {
        return rejectWithValue("Update failed");
      }

    } catch (error: any) {
      return rejectWithValue(error.message);
    }

  }
);
export const bulkCreateThunk = createAsyncThunk(
  "organization/bulkCreateThunk",
  async ({ table, data }: { table: string; data: Record<string, any>[] }, { rejectWithValue, dispatch }) => {
    console.log("bulkCreateThunk params", { table, data });
    const url = `${dataServer}bulk-create`;
    try {
      const result = await createDocument(
        url,
        { table, data }
      )
      console.log("bulkCreateThunk result", result);
      // dispatch(setOrgani)
      if (result.success) {
        return {
          table,
          data: result.data
        };
      } else {
        return rejectWithValue("Update failed");
      }

    } catch (error: any) {
      return rejectWithValue(error.message);
    }

  }
);
export const createProviderThunk = createAsyncThunk(
  "organization/createProviderThunk",
  async ({ provider, orgId, user }:
    { provider: Record<string, any>, orgId: number, user: Record<string, any> | null }, { rejectWithValue, dispatch }) => {
    console.log("createProviderThunk params", { provider });
    const url = `${dataServer}providers`;
    try {

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ provider, orgId, user }),
      });
      const data = await response.json();
      console.log("updateDocument response", data);
      if (!response.ok) {
        throw new Error(data);
      }
      return data;


    } catch (error: any) {
      return rejectWithValue(error.message);
    }

  }
);
export type CreateUserParams = {
  user: Record<string, any>,
  orgId: number,
  roleId: number,
  providerId: number | null,
}
export const createUserThunk = createAsyncThunk(
  "organization/createUserThunk",
  async (
    { user, orgId, providerId, roleId }:
      CreateUserParams, { rejectWithValue, dispatch }) => {
    console.log("createUserThunk params", { user, roleId });
    const url = `${dataServer}users`;
    try {

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user, orgId, providerId, roleId }),
      });
      const data = await response.json();
      console.log("updateDocument response", data);
      if (!response.ok) {
        throw new Error(data);
      }

      return data;

    } catch (error: any) {
      return rejectWithValue(error.message);
    }

  }
);


export const createSurveysThunk = createAsyncThunk(
  "organization/createSurveysThunk",
  async ({ surveys }: { surveys: Survey[] }, { rejectWithValue, dispatch, getState }) => {
    console.log("createSurveysThunk params", { surveys });
    const url = `${dataServer}surveys`;
    const state = getState() as RootState;
    let processTasks = state.organization.processTasks
    
    console.log("createSurveysThunk getState", { processTasks });
    try {

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ surveys, processTasks }),
      });
      const data = await response.json();
      console.log("updateDocument response", data);
      if (!response.ok) {
        throw new Error(data);
      }

      return data;

    } catch (error: any) {
      return rejectWithValue(error.message);
    }


  }
);
export const createAssetThunk = createAsyncThunk(
  "organization/createAssetThunk",
  async ({ asset }: { asset: Partial<Asset> }, { rejectWithValue, dispatch, getState }) => {
    console.log("createAssetThunk params", { asset });
    const url = `${dataServer}assets`;
    const state = getState() as RootState;

    try {

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ asset }),
      });
      const data = await response.json();
      console.log("updateDocument response", data);
      if (!response.ok) {
        throw new Error(data);
      }

      return data;

    } catch (error: any) {
      return rejectWithValue(error.message);
    }


  }
);

export const createModelAndElementsThunk = createAsyncThunk(
  "createModelAndElementsThunk",
  async ({ model, saveData }: { model: BridgeModel | null; saveData: SaveElementsData | null }, { rejectWithValue, dispatch, getState }) => {
    console.log("createModelAndElementsThunk params", { model, saveData });
    const url = `${dataServer}models`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ model, saveData }),
      });
      const data = await response.json();
      console.log("updateDocument response", data);
      if (!response.ok) {
        throw new Error(data);
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const generateReportThunk = createAsyncThunk(
  "generateReportThunk",
  async ({ report }: { report: any }, { rejectWithValue, dispatch, getState }) => {
    console.log("generateReportThunk params", { report });
    const url = `${uploadsServer}reports`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ report }),
      });
      const data = await response.json();
      console.log("updateDocument response", data);
      if (!response.ok) {
        throw new Error(data);
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);



